'use client';
import Link from 'next/link';
import { head, map, size } from 'lodash';
import Button from '@/components/shared/Button';
import { Subject } from '@/graphql/queries/pages/central-de-ajuda/types';
import { sheetStore } from '../ProductLayout/stores/sheetStore';
import { SubjectBlock } from './SubjectBlock';

type SubjectsProps = {
  subjects: Subject[];
  categorySlug: string;
};

export const Subjects = ({ subjects, categorySlug }: SubjectsProps) => {
  const setOpenSheetRepresentatives = sheetStore((state) => state.setOpenSheetPartners);
  return (
    <div className="flex flex-col gap-10">
      {map(subjects, (item, index) => {
        if (size(item.question) <= 0) return null;
        return (
          <SubjectBlock
            key={item.id}
            title={item.title}
            categorySlug={categorySlug}
            heading={index === 0 ? 'h1' : 'h2'}
            links={item.question}
            actions={
              <>
                {head(item.actions)?.links?.map((action) => (
                  <Button asChild key={action.id}>
                    <Link
                      href={action.url ?? ''}
                      target={action.target ?? '_self'}
                      aria-label={action.ariaLabel ?? ''}
                    >
                      {action.label}
                    </Link>
                  </Button>
                ))}
                {head(item.actions)?.sheet && (
                  <Button
                    key="asdf"
                    className="text-white"
                    onClick={() => setOpenSheetRepresentatives(true)}
                  >
                    {head(item.actions)?.sheet}
                  </Button>
                )}
              </>
            }
          />
        );
      })}
    </div>
  );
};
